import { z } from 'zod';

// Joburile de extragere SEAP (coada `seap_extract`) — docs/18 §4, docs/20.
// Aceleasi tipuri ca in constrangerea din ops.jobs (migrarea 20261031100300_ops.sql).

export const JOB_TYPES = [
  'manual',
  'scheduled',
  'backfill',
  'refresh_entities',
  'limit_test',
] as const;
export const JobType = z.enum(JOB_TYPES);
export type JobType = z.infer<typeof JobType>;

// Tipurile pe care worker-ul v2 le stie rula: extragerea pe zile x categorii.
export const EXTRACTION_JOB_TYPES: readonly JobType[] = ['manual', 'scheduled', 'backfill'];

export const JOB_STATUSES = ['queued', 'running', 'done', 'error', 'cancelled'] as const;
export const JobStatus = z.enum(JOB_STATUSES);
export type JobStatus = z.infer<typeof JobStatus>;

// Categoriile CPV ale SEAP (seap.cpv_categories): 1..12, plus 0 = fara filtru (plasa de siguranta).
export const SEAP_CATEGORY_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export const SeapCategoryId = z.number().int().min(0).max(12);

const Day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'zi in formatul YYYY-MM-DD');

// params pentru manual / scheduled / backfill. Strict: un camp necunoscut (o greseala de scris)
// face jobul sa pice imediat, nu sa ruleze altceva decat s-a cerut.
export const ExtractJobParams = z.strictObject({
  days: z.array(Day).min(1).max(366),
  // Lipsa sau goala = toate cele 12.
  categories: z.array(SeapCategoryId).optional(),
  // Achizitiile care au deja detalii nu se mai cer la SEAP (implicit da).
  skip_existing: z.boolean().optional(),
  // Datele furnizorilor (getSUEntityView); implicit setarea worker-ului.
  fetch_suppliers: z.boolean().optional(),
});
export type ExtractJobParams = z.infer<typeof ExtractJobParams>;
